<template>
  <el-form-item
    :title="info"
    :label="label"
    :required="required"
    :class="getError ? 'is-error' : ''"
  >
    <span slot="label" style="color: #636363" v-if="label">
      <span>
        {{ label }}

        <a href="#" v-if="info">
          <i class="fa fa-question-circle" aria-hidden="true"></i>
        </a>
      </span>
    </span>

    <slot />

    <div
      v-if="getError && getError.length"
      class="text-left mt-1"
      style="color: #e66666; font-size: 9pt"
    >
      {{ getError.join(', ') }}
    </div>
  </el-form-item>
</template>

<script>
import EdFormMixin from "./mixins/formControl";

export default {
  name: "EdInputItem",
  mixins: [EdFormMixin],
  props: {
    type: {
      type: String,
      required: false,
      default: "text",
    },
    maxlength: {
      type: [String, Number],
      required: false,
      default: 99999,
    },
  },
  data() {
    return {};
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {
    getError(){
      if(this.$root.$request.dados && 
        this.$root.$request.dados.status == 400 && 
        this.$root.$request.dados.options && 
        this.$root.$request.dados.options.data &&
        this.name
      ){
        return this.$root.$request.dados.options.data[this.name];
      }
    }
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// EdInputItem.vue?6562fc47